import type { Kind } from "@/modules/eventDetails/client/api/types"
import type { EventType } from "@/modules/events/client/types"
import type { TranslationKey } from "@/modules/i18n/components/types"

import { EVENT_KINDS } from "@/modules/eventDetails/client/constants"
import { EVENT_TYPES } from "@/modules/events/client/constants"

// Type check for Event Details (prefixed) types
function isKind(eventType: string): eventType is Kind {
  return (EVENT_KINDS as ReadonlyArray<Kind>).includes(eventType)
}

// Type check for Generic (non prefixed) EventType
function isEventType(eventType: string): eventType is EventType {
  return (EVENT_TYPES as ReadonlyArray<EventType>).includes(eventType)
}

export const getEventTypeTranslation = (eventType: string): TranslationKey<"event_details" | "events"> | "" => {
  if (isKind(eventType)) {
    const kindKey = eventType.replace("event_kind_", "")
    return `event_details.tags.${kindKey}`
  }

  if (isEventType(eventType)) {
    return `events.type.${eventType}`
  }

  return ""
}
